import { types } from 'mobx-state-tree';

//This is the sample store created using MST.
const User = types
  .model({
    firstName: '',
    lastName: '',
  })
  .views((self) => ({
    get fullName() {
      return `${self.firstName} ${self.lastName}`;
    },
  }));

export default User;
